<template>
  <div class="hello">
    <!--h1>{{ msg }}</h1-->
    <b-card>
      <b-media right-align>
        <b-media-body class="ml-3" align="left">
          <h4 class="mt-0"> 일반 현황 </h4>
          <p>
            저희 <b>㈜한흥실업</b> 은 석분 제조업체로 1981년부터 시작하여 현재까지 <b>가축사료의 원료</b>, <b>석회고토비료</b>, <b>도로포장용 채움재</b>, <b>타일 및 백시멘트 원료</b> 등을 생산하는 업체 입니다.
          </p>
        </b-media-body>
      </b-media>
      <b-table stacked :items="item1">
      </b-table>
    </b-card>
    <b-card>
      <b-media right-align>
        <b-media-body class="ml-3" align="left">
          <h4 class="mt-0">회사 연혁</h4>
        </b-media-body>
      </b-media>
      <b-table :items="item2" :fields="fields"></b-table>
    </b-card>
    <b-card>
      <b-media right-align>
        <b-media-body class="ml-3" align="left">
          <h4 class="mt-0">수상 현황</h4>
        </b-media-body>
      </b-media>
      <b-table :items="item3" :fields="fields"></b-table>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'Intro',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      item1: [
        { 대표이사: '정 문 희', 사업분야: '가축사료, 석회비료, 도로포장재, 백시멘트원료', 설립일자: '1981.04.01', 전화번호: '02-783-8921', 팩스번호: '02-783-8926', 회사주소: '충청북도 괴산군 연풍면 은티중리길 248' }
      ],
      item2: [
        { '일  자': '1981', '내  용': '(주)한흥실업 법인설립 / (주)한흥실업 명의 광업권 등록 / 한흥분체 청주공장 법인 합병 후 지점 승격' },
        { '내  용': '종로구 내수동 154 본점' },
        { '일  자': '1983', '내  용': '영등포구 여의대방로 69길 7 지점 설립' },
        { '일  자': '1986', '내  용': '단미사료 제조업 등록' },
        { '일  자': '1988', '내  용': '연풍 제 2 공장 증설' },
        { '일  자': '1993', '내  용': '윤활유 수출입' },
        { '일  자': '1994', '내  용': '역청포장용 채움재 KS 취득' },
        { '일  자': '1996', '내  용': '석회질 비료 단체 표준 품질 인증 승인' },
        { '일  자': '1998', '내  용': '비금속 광산물 채취 및 판매업 / 석회석분 제조 판매업' },
        { '일  자': '2001', '내  용': '석회석 비료 우수단체 표준 제품 승인' },
        { '일  자': '2002', '내  용': '괴산군 연풍면 은티중리길 248 본점 이전' },
        { '일  자': '2005', '내  용': '노천채광에서 갱내채광으로 전환' },
        { '일  자': '2009', '내  용': '1공장-2공장 시설 설비 증설' },
        { '일  자': '2018', '내  용': '정 문 희 대표이사 취임' },
        { '일  자': '2020', '내  용': '서울 사무실 이전' }
      ],
      item3: [
        { '일  자': '2018', '내  용': '충청북도 고용우수기업 인증' },
        { '일  자': '2018', '내  용': '충청북도 2018 노인 일자리 창출 우수기업 인증' },
        { '일  자': '2018', '내  용': '중소기업벤처기업청 여성기업 확인서 발급' }
      ],
      fields: [ '일  자', '내  용' ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/components/Intro.vue